import { getApiActionTypes } from '../storeHelpers';

export const fetchAttachmentDetailsTypes = getApiActionTypes(
  'VIEW_PRINT_ATTACHMENT_DETAILS/FETCH_ATTACHMENT_DETAILS',
);
